module.exports = __webpack_public_path__ + "images/shanxi_banner03.jpg?7d629b177abb1b9fc408e31e56805a95";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/shanxi_banner03.jpg
// module id = 192
// module chunks = 1